<template>
  <div>
    <KFormDesign ref="design" @handleSave="handleSave" />
  </div>
</template>
<script>
  import { KFormDesign } from '@/components';
  import Query from '@/api/dto/admin/Query'
  export default {
    components: {
      KFormDesign
    },
    methods: {
      handleSave(val) {
        const params={
          id:null,
          no:val.dataSource.no,
          name:val.dataSource.name,
          type:parseInt(val.dataSource.type) ,
          sql:val.dataSource.sql,
          columns:val.dataSource.columns,
          customized:false,
          queryTerms:JSON.stringify({
            list:val.list,
            config:val.config,
            paramModel:val.dataSource.paramModel,
            apiDesc:val.dataSource.apiDesc,
            queryType:val.dataSource.queryType
          }),
          version:0
        }
        const query = new Query(params);
        const that=this
        Query.saveQuery(query).then((body)=>{
          that.$message.success('触发保存方法');
          console.log(val);
        }).catch((err)=>{
          alert(err)
        })

      }
    }
  };
</script>
